import { Component, OnDestroy, OnInit } from '@angular/core';
import { PopupService } from '../../shared/modal/popup.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from '../../shared/core-utils';
import { AlertService } from '../../shared/alert/alert.service';
import { CropSettingsContext } from '../crop-Settings.context';
import { LocationService } from '../../shared/location/service/location.service';
import { LocationType } from '../../shared/location/model/location-type';
import { Location } from '../../shared/location/model/location';
import { MAX_PAGE_SIZE } from '../../app.constants';
import { LocationSearchRequest } from '../../shared/location/model/location-search-request.model';
import { LocationTypeEnum } from '../../shared/location/model/location-type.enum';
import { HttpResponse } from '@angular/common/http';
import { finalize } from 'rxjs/internal/operators/finalize';

@Component({
    selector: 'jhi-location-edit-dialog',
    templateUrl: './location-edit-dialog.component.html'
})
export class LocationEditDialogComponent implements OnInit, OnDestroy {
    readonly FORBIDDEN_CHARACTERS = "['<', '>', '?', '%', '|', '/']"

    PAGINATION = {
        page: 0,
        size: MAX_PAGE_SIZE
    };

    NON_SPECIFY_LOCATION_ID = '-1';

    locationId: number;
    name: string;
    abbreviation: string;
    locationTypeId: number;
    countryId: number;
    parentLocationId: number;
    isLoading: boolean;
    locationRequest: any;

    locationTypes: LocationType[] = [];
    countries: Location[] = [];
    provinces: Location[] = [];

    nonSpecifyLocation: Location = new Location(-1);
    constructor(public activeModal: NgbActiveModal,
                private eventManager: JhiEventManager,
                private locationService: LocationService,
                private alertService: AlertService,
                private cropSettingsContext: CropSettingsContext) {

        this.locationRequest = {
            name: null, abbreviation: null, type: null, countryId: null,
            provinceId: null, latitude: null, longitude: null, altitude: null, parentLocId: null
        };
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save(f) {
        if (!this.isFormValid(f)) {
            return;
        }

        this.isLoading = true;

        if (this.locationRequest.name) {
            this.locationRequest.name = this.locationRequest.name.trim();
        }

        if (this.locationRequest.abbreviation) {
            this.locationRequest.abbreviation = this.locationRequest.abbreviation.trim();
        }

        this.locationRequest.parentLocId = this.parentLocationId;
        if (this.locationId) {
            this.locationService.updateLocation(this.locationRequest, this.locationId).pipe(
                finalize(() => this.isLoading = false)
            ).subscribe(() => {
                this.alertService.success('crop-settings-manager.location.modal.edit.success');
                this.notifyChanges();
                this.isLoading = false;
            });
        } else {
            this.locationService.createLocation(this.locationRequest).pipe(
                finalize(() => this.isLoading = false)
            ).subscribe(() => {
                this.alertService.success('crop-settings-manager.location.modal.create.success');
                this.notifyChanges();
                this.isLoading = false;
            });
        }
    }

    isFormValid(f) {
        return f.form.valid && //
            !this.isLoading && //
            this.locationRequest.name && //
            this.locationRequest.type && //
            this.locationRequest.abbreviation //
    }

    notifyChanges(): void {
        this.eventManager.broadcast({ name: 'locationViewChanged' });
        this.clear();
    }

    ngOnInit(): void {
        this.locationService.getLocationTypes(true).toPromise().then((locationTypes: LocationType[]) => {
            this.locationTypes = locationTypes;
            if (this.cropSettingsContext.location) {
                this.locationRequest.type = this.cropSettingsContext.location.type;
            }

        });

        if (this.cropSettingsContext.location) {
            this.locationId = this.cropSettingsContext.location.id;
            this.parentLocationId = this.cropSettingsContext.location.parentLocId;
            this.locationRequest.name = this.cropSettingsContext.location.name;
            this.locationRequest.abbreviation = this.cropSettingsContext.location.abbreviation;
            this.locationRequest.parentLocId = this.parentLocationId;

            this.locationRequest.latitude = this.cropSettingsContext.location.latitude;
            this.locationRequest.longitude = this.cropSettingsContext.location.longitude;
            this.locationRequest.altitude = this.cropSettingsContext.location.altitude;

        }
    }

    countryChanged(): void {
        if (this.locationRequest.countryId !== this.NON_SPECIFY_LOCATION_ID) {
            const provincesSearchRequest: LocationSearchRequest = new LocationSearchRequest();
            provincesSearchRequest.countryIds = [this.locationRequest.countryId];
            provincesSearchRequest.locationTypeIds = [LocationTypeEnum.PROVINCE];
            this.locationService.searchLocations(provincesSearchRequest, false, this.PAGINATION)
                .subscribe(
                    (resp: HttpResponse<Location[]>) => {
                        this.provinces = resp.body;
                        this.provinces.unshift(this.nonSpecifyLocation);
                    });
        } else {
            this.locationRequest.countryId = null;
            this.provinces = [];
        }
        this.locationRequest.provinceId = null;
    }

    provinceChanged(): void {
        this.locationRequest.provinceId = this.locationRequest.provinceId === this.NON_SPECIFY_LOCATION_ID ? null : this.locationRequest.provinceId;
    }

    ngOnDestroy(): void {
        this.cropSettingsContext.location = null;
    }

}

@Component({
    selector: 'jhi-location-edit-popup',
    template: ''
})
export class LocationEditPopupComponent implements OnInit {

    constructor(private popupService: PopupService) {
    }

    ngOnInit(): void {
        this.popupService.open(LocationEditDialogComponent as Component, { modalDialogClass: 'modal-md', backdrop: 'static' });
    }
}
